.total {
  font-weight: 600;
}

.formula {
  color: var(--grey-900);
}
